import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { green } from "@mui/material/colors";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import NameLetter from "../nameLetter";
import Tooltip from "@mui/material/Tooltip";
import "./userCard.scss";
import { useState } from "react";
import TimestampConverter from "../../chat/chatHistory/timeStampConvertor";
import { Skeleton } from "@mui/material/Skeleton";
import { styled, useTheme } from "@mui/material/styles";
const UserCard = ({
  name,
  last_reply_time,
  unread_msg_count,
  last_message,
  func,
  variant,
  isActive,
}) => {
  const containsHTML = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return doc.body.children.length > 0;
  };
  
  function getLastMsg(last_message){
    const match = last_message.match(/<span class=['"]rec_msg['"]>(.*?)<\/span>/);
    const extractedText = match ? match[1] : null;
    if (extractedText){
      return extractedText
    }else{
      if(last_message){
        if(containsHTML(last_message)){
          return "User Input Prompt";
      }else{
        return last_message
      }
    }
  }
}
  const theme = useTheme();
  return (
    <>
    
      <Card
        sx={{ minWidth: "100%", borderRadius: '0', borderColor: theme.palette.customColor.cardBorderColor, backgroundColor: isActive ? theme.palette.customColor.cardActive : theme.palette.customColor.cardBg}}
        variant={variant}
        className={`user-card ${isActive ? "active" : ""}`}
        onClick={func}
      >
        <CardActionArea
          className="user-entry-card"
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "16px",
            borderRadius: "0px",
            width:'100%'
          }}
        >
          {/* <Avatar alt="user" src={profileImg} /> */}
          <NameLetter nameLetter={Array.from(name)[0]} nameType="icon" />

          <Typography
            component={"span"}
            className="user-details"
            sx={{
              width:'calc(100% - 50px)',
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography component="span" className="user-name-desc">
              <Typography sx={{textTransform:'capitalize'}} component="span" noWrap>
              <Tooltip title={name} followCursor>{name}</Tooltip>
              </Typography>
              <Typography
                sx={{ fontSize: "1.3rem", lineHeight: '1.3' }}
                color="text.secondary"
                component="span"
                noWrap
              >
                {getLastMsg(last_message)}
              </Typography>
            </Typography>

            <Typography
              component="span"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              {last_reply_time > 0 && (
                <Typography
                  sx={{ fontSize: "1rem", ml: 1, fontWeight: '500' }}
                  color={unread_msg_count !== 0 && !isActive ? '#1fa855' : '#667781' }
                  component="span"
                >
                  <TimestampConverter
                    time={last_reply_time}
                    callFrom="userCard"
                  />
                </Typography>
              )}

              {unread_msg_count !== 0 && (
                <Avatar
                  sx={{
                    bgcolor: green[500],
                    minWidth: 18,
                    width: 'inherit',
                    height: 18,
                    borderRadius: 10,
                    padding: '0 5px',
                    fontSize: "1.2rem",
                    ml: 1,
                  }}
                >
                  {unread_msg_count > 99 ? '99+':unread_msg_count}
                </Avatar>
              )}
            </Typography>
          </Typography>
        </CardActionArea>
      </Card>
      <Divider sx={{borderColor: 'rgba(0,0,0,.01)'}} />
    </>
  );
};

export default UserCard;
